function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-158.47 -32.75)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 158.47 30.183)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m101.07 52.216v43.806h-93.087c-2.205 0-4.2004-0.8929-5.6444-2.3369s-2.3368-3.4394-2.3368-5.6444c0-4.4075 15.96-59.319 15.96-59.319h85.108v8.6535z",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.181 27.775v-18.071h12.504v64.939h-12.504v-45.922z",
  fill: "#f7b239"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#b27214"
}, /*#__PURE__*/React.createElement("path", {
  d: "m37.021 16.159h-4.8403v4.0337h4.8403z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.021 44.956h-4.8403v4.0338h4.8403z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.021 35.354h-4.8403v4.0338h4.8403z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.021 25.756h-4.8403v4.0338h4.8403z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.021 64.154h-4.8403v4.0337h4.8403z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.021 54.554h-4.8403v4.0338h4.8403z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m107.18 44.794h0.094c0 2.5439-0.578 5.0824-1.734 7.422h-29.903v-0.0027c1.0218-2.3665-0.9546-4.8916-0.9546-7.4193z",
  fill: "#f95428"
}), /*#__PURE__*/React.createElement("path", {
  d: "m74.682 44.794c0-2.5251 1.9766-5.0501 0.9546-7.4166v-0.0027h29.903c1.156 2.3368 1.734 4.8808 1.734 7.4193h-0.094z",
  fill: "#f95428"
}), /*#__PURE__*/React.createElement("path", {
  d: "m109.67 43.448h-34.988v2.6891h34.988z",
  fill: "#e54728"
}), /*#__PURE__*/React.createElement("path", {
  d: "m113.26 37.375c1.157 2.3368 1.735 4.8808 1.735 7.4193 0 2.5439-0.578 5.0825-1.735 7.422h-8.532c1.156-2.3395 1.734-4.8781 1.734-7.422 0-2.5385-0.578-5.0825-1.734-7.4193z",
  fill: "#2ba5f7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m70.444 40.857c0.7583 1.124 4.238 2.4795 4.238 3.937 0 1.4602-3.477 2.8128-4.238 3.9396l-5.8757-3.9396z",
  fill: "#f95428"
}), /*#__PURE__*/React.createElement("path", {
  d: "m75.637 37.377c1.0217 2.3665 1.5354 4.8915 1.5354 7.4166 0 2.5278-0.5137 5.0528-1.5354 7.4193v0.0027l-5.1928-3.4823c0.761-1.1267 1.1995-2.4795 1.1995-3.9397 0-1.4575-0.4409-2.8128-1.1995-3.9369l5.1928-3.4824z",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.96 28.721v51.338h-7.9785c-4.4075 2e-4 -7.9813 3.574-7.9813 7.9815v-67.301c0-1.0999 0.22326-2.1513 0.62666-3.1059s0.98963-1.8151 1.7102-2.5386c1.444-1.444 3.4394-2.3368 5.6444-2.3368h7.9785z",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m99.355 105.3h-45.712v-45.712l36.156 36.156zm-37.954-7.7583h19.225l-19.225-19.225z",
  fill: "#2ba5f7"
})));

function SvgGraphicDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30.425mm",
    height: "25.293mm",
    viewBox: "0 0 30.425 25.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesign);
export default __webpack_public_path__ + "static/media/graphic-design.e2325bf0.svg";
export { ForwardRef as ReactComponent };